export function getBuildVersion(): string {
  return import.meta.env.VITE_BUILD_NUMBER || 'unknown';
}
